import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { bindActionCreators, compose } from 'redux';
import get from 'lodash/get';
import { getActiveUser } from '../../shared/redux/selectors';

import {
  loadAgency,
  loadCampaign,
  loadEngagementsForCampaign,
  loadActiveUser,
  loadPaymentMethodsForAgency,
  loadBrandsForAgency
} from '../../shared/redux/entities/actions';

function mapStateToProps(state){
  const activeUser = getActiveUser(state);

  return {
    activeUser:activeUser,
    activeAgency:get(state,['entities','agencies',activeUser.agencyId],{})
  };
}

function mapDispatchToProps(dispatch){
  return bindActionCreators({
    loadActiveUser,
    loadAgency,
    loadEngagementsForCampaign,
    loadPaymentMethodsForAgency,
    loadBrandsForAgency,
    loadCampaign
  },dispatch);
}

export default compose(
  withRouter,
  connect(mapStateToProps,mapDispatchToProps)
);



// WEBPACK FOOTER //
// ./src/routes/OnboardingTutorial/connect.js